import axios from "axios";

function getApiBaseUrl() {
  return process.env.REACT_APP_API_URL || "";
}

function getAuthHeaders() {
  const token =
    localStorage.getItem("sundorbonToken") ||
    localStorage.getItem("token") ||
    sessionStorage.getItem("sundorbonToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function normalizeListResponse(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.data)) return data.data;
  return [];
}

/**
 * GET Notification/user/{userId}
 */
export async function fetchUserNotifications(
  userId,
  { unreadOnly = false, page = 1, pageSize = 20 } = {},
) {
  const { data } = await axios.get(
    `${getApiBaseUrl()}Notification/user/${userId}`,
    {
      params: { unreadOnly, page, pageSize },
      headers: getAuthHeaders(),
    },
  );
  return normalizeListResponse(data);
}

/**
 * POST Notification/recipient/{recipientId}/read?userId={userId}
 */
export async function markNotificationRecipientRead(recipientId, userId) {
  await axios.post(
    `${getApiBaseUrl()}Notification/recipient/${recipientId}/read`,
    null,
    {
      params: { userId },
      headers: getAuthHeaders(),
    },
  );
}

/**
 * POST Notification/user/{userId}/read-all
 */
export async function markAllUserNotificationsRead(userId) {
  await axios.post(
    `${getApiBaseUrl()}Notification/user/${userId}/read-all`,
    null,
    { headers: getAuthHeaders() },
  );
}
